<template>
    <template v-if="!$store.state.waitingRequest">
        <p v-show="alert.length" :key="alertId" class="popup-message" :style="[alert[0] == 0 ? {'background-color': '#e74c3c'} : {'background-color': '#26a65b'}]">{{ alert[1] }}</p>

        <main>
            <h1>Création d'un compte</h1>
            <p v-if="sameIpCount > 0" class="ip-exists">Attention, tu as déjà créé <b>{{ sameIpCount }}</b> {{ sameIpCount == 1 ? 'compte' : 'comptes' }} avec cette <a href="https://fr.vikidia.org/wiki/Adresse_IP" target="_blank">adresse ip</a>. Si tu as perdu ton mot de passe, récupère-le ici.</p>

            <section class="register">
                <form action="" method="POST" @submit.prevent="validation">
                    <div class="form-overlay" v-if="formDisabled"></div>

                    <p v-if="birthDateError">{{ birthDateError }}</p>
                    <label>Ta date de naissance</label>
                    
                    <div class="birth-select">
                        <select v-model="birthDay" @change="birthDateErrors">
                            <option disabled value="0">Jour</option>
                            <option v-for="i in 31" :value="i" :key="i">{{ i }}</option>
                        </select>

                        <select v-model="birthMonth" :disabled="!steps[0]" @change="birthDateErrors">
                            <option disabled value="0">Mois</option>
                            <option v-for="i in months" :value="i.value" :key="i.value">{{ i.name }}</option>
                        </select>

                        <select v-model="birthYear" :disabled="!steps[1]" @change="birthDateErrors">
                            <option disabled value="0">Année</option>
                            <option v-for="i in years" :value="i" :key="i">{{ i }}</option>
                        </select>
                    </div>

                    <p v-if="pseudoError">{{ pseudoError }}</p>
                    <input type="text" placeholder="Ton pseudo" :value="pseudo" @input="pseudo= $event.target.value" @keyup="pseudoErrors" :class="{ border: pseudoError }" :disabled="!steps[2]" />

                    <p v-if="emailError">{{ emailError }}</p>
                    <input type="text" placeholder="Ton e-mail" :value="email" @input="email= $event.target.value" @keyup="emailErrors" :class="{ border: emailError }" :disabled="!steps[3]" />

                    <p v-if="passwordError">{{ passwordError }}</p>
                    <input type="password" placeholder="Ton mot de passe" :value="password" @input="password= $event.target.value" @keyup="passwordErrors" :class="{ border: passwordError }" :disabled="!steps[4]" />

                    <p v-if="confirmPasswordError">{{ confirmPasswordError }}</p>
                    <input type="password" placeholder="Confirme ton mot de passe" :value="confirmPassword" @input="confirmPassword= $event.target.value" @keyup="confirmPasswordErrors" :class="{ border: confirmPasswordError }" :disabled="!steps[5]" />
                    
                    <p v-if="rulesError">{{ rulesError }}</p>
                    <div class="rules">
                        <div class="toggle-switch" @click="handleRules" :style="[rulesAccepted ? {'background-color': '#00B7E8'} : {'background-color': '#dbdee2'}]">
                            <div class="inner-toggle" :style="[rulesAccepted ? {'margin-left': 'calc(100% - 11px)'} : {'margin-left': '0'}]"></div>
                        </div>
                        <p @click="handleRules">J'accepte les <a href="https://clicktestcps.fr/cgu.html" target="_blank">conditions générales d'utilisation</a>.</p>
                    </div>

                    <input type="text" placeholder="Autre (laisser vide)" :value="autre" @input="autre= $event.target.value" class="autre" autocomplete="false" />

                    <input type="submit" value="Je m'inscris !" :disabled="formDisabled">
                    
                    <router-link to="/login" class="login-link" :style="[formDisabled ? {'color': '#d6d6d6'} : {'color': '#2e2963'}]">Je suis déjà inscrit(e), me connecter</router-link>
                </form>

                <div class="summary">
                    <h2>Inscris-toi gratuitement !</h2>
                    <ul>
                        <li><i class="fas fa-cloud-download-alt"></i> Sauvegarde tes données</li>
                        <li><i class="fas fa-users"></i> Fais-toi des amis</li>
                        <li><i class="fas fa-trophy"></i> Récompenses exclusives</li>
                    </ul>

                    <p>Améliore ton expérience de jeu en devenant un(e) membre de Games™.</p>
                    <p>Promis, nous ne te submergerons pas de mails.</p>
                </div>
            </section>

            <div class="ad-banner">
                <ins class="adsbygoogle"
                data-ad-client="ca-pub-2512331316053279"
                data-ad-slot="6346220535"></ins>
            </div>
        </main>
    </template>
    <template v-else>
        <SkeletonCategorie />
    </template>
</template>

<script>
import SkeletonCategorie from '../components/SkeletonCategorie.vue';
import AddGoogleScripts from '../mixins/addGoogleScripts';

export default {
    name: 'Register',
    mixins: [AddGoogleScripts],
    components: {
        SkeletonCategorie
    },
    data() {
        return {
            requestsNb: 0,

            steps: [],
            birthDay: 0,
            birthMonth: 0,
            birthYear: 0,
            months: [],
            years: [],
            pseudo: '',
            email: '',
            password: '',
            confirmPassword: '',
            autre: '',

            rulesAccepted: false,

            formDisabled: true,

            logins: [],
            emails: [],
            sameIpCount: 0,

            birthDateError: '',
            pseudoError: '',
            emailError: '',
            passwordError: '',
            confirmPasswordError: '',
            rulesError: '',

            alert: [],
            alertId: 0,

            metas : {
                title: "ClickTestCPS Games™ - Création d'un compte",
                meta: [
                    {
                        name: 'description',
                        content: 'Créez un compte pour accéder à de nouvelles fonctionnalités sur le site. Sauvegardez vos données et améliorez votre expérience de jeu !'
                    },
                    {
                        name: 'keywords',
                        content: 'ClickTestCPS, ClickTestCPS.fr, Compte games clicktestcps, ctcps games, ClickTestCPS games, créer compte clicktestcps, Favoris jeux ctcps games, Compte click test'
                    },
                    {
                        property: 'og:image',
                        content: 'https://clicktestcps.fr/og-games.png'
                    },
                    {
                        property: 'og:title',
                        content: 'Jeux en ligne gratuits en un clic - Jeu FR '+new Date().getFullYear()+' sans inscription - Games™ par ClickTestCPS'
                    },
                    {
                        property: 'og:description',
                        content: 'Jouez à des centaines de jeux en ligne gratuitement et sans inscription. Une sélection unique de jeux en ligne gratuits alimentée quotidiennement'
                    }
                ]
            }
        }
    },
    mounted() {
        useHead(this.metas);
        this.$store.commit('setRequestTrue');

        this.months = [
            { value: '1', name: 'Janvier' },
            { value: '2', name: 'Février' },
            { value: '3', name: 'Mars' },
            { value: '4', name: 'Avril' },
            { value: '5', name: 'Mai' },
            { value: '6', name: 'Juin' },
            { value: '7', name: 'Juillet' },
            { value: '8', name: 'Août' },
            { value: '9', name: 'Septembre' },
            { value: '10', name: 'Octobre' },
            { value: '11', name: 'Novembre' },
            { value: '12', name: 'Décembre' }
        ];
        
        this.years = Array.from({length: 71}, (value, index) => new Date().getFullYear() - 73 + index);
        this.years.reverse();
        this.steps = [false, false, false, false, false, false, false];
        
        this.checkSession();
        this.getAllLogins();
        this.getAllEmails();
        this.memberSameIpCount();
    },
    methods: {
        checkSession() {
            let formData = new FormData();
            formData.append('data', JSON.stringify({ post: "1" }));

            axios
            .post(this.$store.state.apiUrl+"?request=checkSession", formData, { withCredentials: true })
            .then((response) => {
                if(response.data) {
                    this.$router.replace({ name: 'userPanel' });
                }
            }).finally(() => {
                this.$store.commit('setRequestFalse');
            });
        },
        getAllLogins() {
            let formData = new FormData();
            formData.append('data', JSON.stringify({ post: "1" }));

            axios
            .post(this.$store.state.apiUrl+"?request=getAllLogins", formData)
            .then((response) => {
                this.logins = response.data;
            }).finally(() => {
                this.requestsNb++;
            });
        },
        getAllEmails() {
            let formData = new FormData();
            formData.append('data', JSON.stringify({ post: "1" }));

            axios
            .post(this.$store.state.apiUrl+"?request=getAllEmails", formData)
            .then((response) => {
                this.emails = response.data;
            }).finally(() => {
                this.requestsNb++;
            });
        },
        memberSameIpCount() {
            let formData = new FormData();
            formData.append('data', JSON.stringify({ post: "1" }));

            axios
            .post(this.$store.state.apiUrl+"?request=memberSameIpCount", formData)
            .then((response) => {
                this.sameIpCount = response.data;
            }).finally(() => {
                this.requestsNb++;
            });
        },
        loginExists() {
            let response = false;
            let loginExists = this.logins.find(key => key.toUpperCase() === this.pseudo.toUpperCase()) != undefined;
            if (loginExists) {
                response = true;
            }
            return response;
        },
        emailExists() {
            let response = false;
            let emailExists = this.emails.find(key => key.toUpperCase() === this.email.toUpperCase()) != undefined;
            if (emailExists) {
                response = true;
            }
            return response;
        },
        birthDateValid() {
            let valid = false;
            
            if(this.birthDay != 0 && this.birthMonth != 0 && this.birthYear != 0) {
                let monthsLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            
                // Année bissextile
                if (this.birthYear % 400 === 0 || (this.birthYear % 100 !== 0 && this.birthYear % 4 === 0)) {
                    monthsLength[1]++;
                }

                if(this.birthDay <= monthsLength[this.birthMonth - 1]) {
                    valid = true;
                }
            }

            return valid;
        },
        pseudoValid() {
            let valid = false;

            if (this.pseudo.trim() && !this.loginExists() && this.pseudo.length >= 3 && this.pseudo.length <= 16) {
                valid = true;
            }
            return valid;
        },
        emailValid() {
            let valid = false;
            let regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (this.email.trim() && !this.emailExists() && regex.test(this.email) && this.email.length <= 254) {
                valid = true;
            }
            return valid;
        },
        passwordValid() {
            let valid = false;
            let regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[^\w\s]).*$/;

            if (regex.test(this.password) && this.password.length >= 8 && this.password.length <= 40) {
                valid = true;
            }
            return valid;
        },
        confirmPasswordValid() {
            let valid = false;

            if (this.password.trim() && this.confirmPassword == this.password) {
                valid = true;
            }
            return valid;
        },
        birthDateErrors() {
            this.checkDisabled();

            if(this.birthDay != 0) {
                this.steps[0] = true;

                if(this.birthMonth != 0) {
                    this.steps[1] = true;

                    if(this.birthYear != 0) {
                        this.birthDateError = '';

                        if (!this.birthDateValid()) {
                            this.steps[2] = false;

                            this.birthDateError = "La date de naissance est incorrecte.";
                        } else {
                            this.steps[2] = true;
                        }
                    }
                }
            }
        },
        pseudoErrors() {
            this.checkDisabled();

            this.pseudoError = '';

            if (!this.pseudoValid()) {
                this.steps[3] = false;

                if (!this.pseudo.trim()) {
                    this.pseudoError = 'Le pseudo est requis.';
                } else {
                    if(this.loginExists()) {
                        this.pseudoError = 'Le pseudo est déjà utilisé.';
                    } else if (this.pseudo.length < 3) {
                        this.pseudoError = 'Le pseudo doit comporter au moins 3 caractères.';
                    } else if (this.pseudo.length > 16) {
                        this.pseudoError = 'Le pseudo ne doit pas dépasser 16 caractères.';
                    }
                }
            } else {
                this.steps[3] = true;
            }
        },
        emailErrors() {
            this.checkDisabled();
            
            this.emailError = '';

            if (!this.emailValid()) {
                this.steps[4] = false;

                if (!this.email.trim()) {
                    this.emailError = "L'adresse e-mail est requise.";
                } else {
                    let regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    
                    if(this.emailExists()) {
                        this.emailError = "L'adresse e-mail est déjà utilisée.";
                    } else if (!regex.test(this.email)) {
                        this.emailError = "L'adresse e-mail est incorrecte.";
                    } else if (this.email.length > 254) {
                        this.emailError = "L'adresse e-mail ne doit pas dépasser 254 caractères.";
                    }
                }
            } else {
                this.steps[4] = true;
            }
        },
        passwordErrors() {
            this.checkDisabled();
            
            this.passwordError = '';

            if (!this.passwordValid()) {
                this.steps[5] = false;

                let regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[^\w\s]).*$/;
                
                if (!regex.test(this.password)) {
                    this.passwordError = "Le mot de passe doit contenir au moins 1 majuscule, 1 minuscule, 1 chiffre et 1 caractère spécial.";
                } else if (this.password.length < 8) {
                    this.passwordError = "Le mot de passe doit comporter au moins 8 caractères.";
                } else if (this.password.length > 40) {
                    this.passwordError = "Le mot de passe ne doit pas dépasser 40 caractères.";
                }
            } else {
                this.steps[5] = true;
            }
        },
        confirmPasswordErrors() {
            this.checkDisabled();
            
            this.confirmPasswordError = '';

            if (!this.confirmPasswordValid()) {
                this.steps[6] = false;

                if (this.confirmPassword != this.password) {
                    this.confirmPasswordError = "Les mots de passe doivent correspondre.";
                }
            } else {
                this.steps[6] = true;
            }
        },
        rulesErrors() {
            this.rulesError = '';

            if (!this.rulesAccepted) {
                this.rulesError = "Le règlement doit être lu et accepté.";
            }
        },
        validation() {
            if (this.birthDateValid() && this.pseudoValid() && this.emailValid() && this.passwordValid() && this.confirmPasswordValid() && !this.autre && this.rulesAccepted) {
                this.createAccount();
            } else {
                this.birthDateErrors();
                this.pseudoErrors();
                this.emailErrors();
                this.passwordErrors();
                this.confirmPasswordErrors();
                this.rulesErrors();
            }
        },
        handleRules() {
            this.rulesAccepted = !this.rulesAccepted;
            this.rulesErrors();
        },
        checkDisabled() {
            if (this.birthDateValid() && this.pseudoValid() && this.emailValid() && this.passwordValid() && this.confirmPasswordValid() && !this.autre) {
                this.formDisabled = false;
            } else {
                this.formDisabled = true;
            }
        },
        createAccount() {
            function handleZeros(nbr) {
                let string = (nbr < 10) ? ('0' + nbr.toString()) : (nbr.toString());
                return string;
            }
            let birthDate = this.birthYear + '-' + handleZeros(this.birthMonth) + '-' + handleZeros(this.birthDay);

            let formData = new FormData();
            formData.append('data', JSON.stringify({
                post: "1",
                pseudo: this.pseudo,
                password: this.password,
                email: this.email,
                birthDate: birthDate
            }));

            axios
            .post(this.$store.state.apiUrl+"?request=createAccount", formData)
            .then((response) => {
                if(response.data) {
                    this.$store.commit('setAccountCreated', true);
                    this.$router.replace({ name: 'login' });
                } else {
                    this.alert = ['0', "Le compte n'a pas pu être créé, réessaye plus tard."];
                    this.alertId++;
                }
            });
        }
    },
    watch: {
        requestsNb() {
            if(this.requestsNb == 4) {
                this.$store.commit('setRequestFalse');
            }
        }
    }
}
</script>

<style scoped src="@/assets/register.css">
</style>